import styled from "styled-components";

import FlexContainer from "@/components/FlexContainer";

export const StyledDashboardTab = styled(FlexContainer)`
    width: 100%;
    flex-direction: column;
    gap: 20px;
    .ant-collapse {
        border-bottom: 1px solid ${({ theme }) => theme.secondaryBorderColor};
        border-radius: 0;
        margin: 0 !important;

        &:last-child {
            border-bottom: none;
        }
    }
`;
